module.exports = __webpack_public_path__ + "media/images/top/img_interview_Yusuke_Tokyo-cf1ac3a939a93a85f303bc983ebd7262.jpg";